import React, { useState } from "react";
import PropTypes from "prop-types";

import { OptionsModal } from "../OptionsModal";
import { Option } from "./Option";
import { List } from "./List";
import { TitleBlock } from "./TitleBlock";
import { Title } from "./Title";
import { Wrapper } from "./Wrapper";
import { ExperimentStep } from "../ExperimentStep";

import "./style.scss";

const SELECT_BUTTON_TEXT = "Select Step";
const MODAL_NAME = "Select a step";

export function StepOptionsModal(props) {
  const [selectedOption, setSelectedOption] = useState(undefined);

  const onSelectOption = (optionID) => () => setSelectedOption(optionID);

  const isOptionSelected = (optionID) => optionID === selectedOption;

  const renderOption = (option) => {
    if (option.visible) {
      const className = isOptionSelected(option.id)
        ? "stepOptionsModal_contentWrapper__list--selected"
        : "";
      return (
        <Option
          className={className}
          key={option.id}
          onClick={onSelectOption(option.id)}
          selected={isOptionSelected(option.id)}
        >
          <ExperimentStep
            onSelect={console.log}
            text={option.text}
            color={option.color}
          />
        </Option>
      );
    } else return null;
  };

  const onSumbitSelection = () => {
    props.onAddStep({ optionId: selectedOption });
  };

  const className = `stepOptionsModal ${props.className}`;
  const optionSelectedClassName = `stepOptionsModal_contentWrapper ${
    selectedOption ? "stepOptionsModal_contentWrapper--selected" : ""
  }`;
  return (
    <OptionsModal
      close={props.close}
      isOpen={props.isOpen}
      buttonText={SELECT_BUTTON_TEXT}
      isOptionSelected={!selectedOption}
      onSumbitSelection={onSumbitSelection}
    >
      <Wrapper className={className}>
        <TitleBlock className="stepOptionsModal_title">
          <Title className="stepOptionsModal_title--title" title={MODAL_NAME} />
        </TitleBlock>
        <Wrapper className={optionSelectedClassName}>
          <List className="stepOptionsModal_contentWrapper__list">
            {props.list.map(renderOption)}
          </List>
        </Wrapper>
      </Wrapper>
    </OptionsModal>
  );
}

StepOptionsModal.propTypes = {
  /**
   * className of the StepOptionsModal
   */
  className: PropTypes.string,
  /**
   * List of options
   */
  list: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Uniqe id of the option
       */
      id: PropTypes.number,
      /**
       * Main title text of the option
       */
      text: PropTypes.string,
      /**
       * Theme color of the option
       */
      color: PropTypes.string,
    })
  ),
  /**
   * Boolean set/reset to open/close modal
   */
  isOpen: PropTypes.bool.isRequired,
  /**
   * Fuction to close modal
   */
  close: PropTypes.func,
  /**
   * function to invoke on submitting selected step option
   */
  onAddStep: PropTypes.func,
};

StepOptionsModal.defaultProps = {
  list: [],
  className: "",
};
